import React from 'react'
import Contact from '../Share/contact/Contact'
import './Footer.css'


const Footer = () => {
  return (
    <footer>
      <Contact></Contact>
      <p className="copyright text-white">
      © Copyright 2020 Lorem Inc. All rights reserved
        by Bipul Hossain
      </p>
    </footer>
  )
}

export default Footer
